<template>
	<div class="app-main home-page">
		<div class="home-top">
			<div class="home-left">
				<img style="width: 100%;height: 120%;" src="../assets/company.png" />
			</div>
			<div class="home-right">
				<div class="qiotice-bar">
					<div class="bar-title">
						<div class="icon-box">
							<img src="../assets/login/tender_icon.svg" />
							<span>企业公告信息栏目</span>
						</div>
						<div class="show-more" @click="showMoreList('company')">查看更多</div>
					</div>
					<div class="notice-box">
						<div class="notice-list" v-for="item in qzNotice" :key="item.id" @click="shouNotice(item)">
							<div class="notice-title">{{item.title}}</div>
							<div class="notice-time">{{item.date}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="home-bottom">
			<div class="home-left">
				<div class="cg-bar">
					<div class="bar-title">
						<div class="icon-box">
							<img src="../assets/login/tender_icon.svg" />
							<span>采购寻源信息栏目</span>
							 <el-radio-group v-model="xunyuanstatus" size="mini" style="margin-left: 10px;">
								<el-radio-button label="0">询价中</el-radio-button>
								<el-radio-button label="1">已完结</el-radio-button>
							</el-radio-group>
						</div>
						<div class="show-more" @click="showMoreList('purchase')">查看更多</div>
					</div>
					<div class="notice-box" v-if="cgxyNotice && cgxyNotice.length>0">
						<div class="notice-list" v-for="item in cgxyNotice" :key="item.id" @click="shouCGNotice(item)">
							<div class="notice-title">{{item.title}}</div>
							<div class="notice-time">{{item.date}}</div>
						</div>
					</div>
					<div class="no-data-img" v-if="!cgxyNotice || cgxyNotice.length==0">
						<img src="../assets/login/no_source.svg"/>
					</div>
				</div>
				<div class="zb-bar">
					<div class="bar-title">
						<div class="icon-box">
							<img src="../assets/login/bid_icon.svg" />
							<span>中标公告信息栏目</span>
						</div>
						<div class="show-more" @click="showMoreList('tender')">查看更多</div>
					</div>
					<div class="notice-box" v-if="zbggNotice && zbggNotice.length>0">
						<div class="notice-list" v-for="item in zbggNotice" :key="item.id" @click="shouZbNotice(item)">
							<div class="notice-title">关于“{{item.orderTitle}}”的中标公示</div>
							<div class="notice-time">{{item.date}}</div>
						</div>
					</div>
					<div class="no-data-img" v-if="!zbggNotice || zbggNotice.length==0">
						<img src="../assets/login/no_notice.svg"/>
					</div>
				</div>
			</div>
			<div class="home-right">
				<div class="msg-bar">
					<div class="bar-title">
						<div class="icon-box">
							<img src="../assets/login/server_icon.svg" />
							<span>通知消息栏目</span>
							<el-radio-group v-model="backstatus" size="mini" style="margin-left: 10px;">
								<el-radio-button label="0">未读</el-radio-button>
								<el-radio-button label="1">已读</el-radio-button>
							</el-radio-group>
						</div>
						<!-- <div class="show-more">查看更多</div> -->
					</div>
					<div class="msg-list-box">
						<div class="msg-list" v-for="item in backlog" :key="item.id" @click="shouMsg(item)">
							<div class="msg-title">{{item.title}}</div>
							<div class="msg-time">{{item.date}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import  { loadAMap } from '../utils/gdMap';
	import { getWeatherInfo,apiGetWeather,getsysMessageList,readySysMessage } from '../api/welcome'
	import { getNoticeList,winBidNoticeList,sourcNoticeList} from '../api/notice'
	export default {
		computed: {
			PAGESIZE:function(){
				return this.$store.getters['app/sizeInfo'];
			},
		},
		data() {
			return {
				weatherInfo:null,
				xunyuanstatus:'0',
				cgxyNotice:[],	// 采购寻源公告
				qzNotice:[],	// 企业公告
				zbggNotice:[],	// 中标公告
				backlog:[],	// 通知待办
				backstatus:'0',
			};
		},
		created(){
			this.getWeatherInit();
			this.apiGetWeather();
			this.getsysMessageList();
			this.getSourcNoticeList();	// 采购寻源公告
			this.getNoticelist();	// 企业公告
			this.winBidNoticeListFun();	// 中标公告
		},
		methods: {
			getWeatherInit(){
				let _this = this;
				loadAMap().then(() => {
                    setTimeout(()=>{
                        _this.getWeatherinfo();
                    },1000)
                }).catch(err => {
                    _this.$message.error('地图组件加载错误，请联系管理员');
                })
			},
			getWeatherinfo(){
				let _this = this;
				console.log('获取天气')
				AMap.plugin('AMap.Weather', function() {
					//创建天气查询实例
					var weather = new AMap.Weather();

					//执行实时天气信息查询
					weather.getLive('娄底市', function(err, data) {
						_this.weatherInfo = data;
						console.log(err, data);
					});
				});
			},
			apiGetWeather(){
				apiGetWeather({city:'湖南'}).then(({data:res})=>{
					console.log(res)
					if(res.data){
						let info = JSON.parse(res.data)
						console.log(info)
					}

				})
			},
			getsysMessageList(){
				getsysMessageList({
					page: 1, //当前页码
					limit: 100, //当前每页显示的数量
					objMap:{
						readed: this.backstatus //readed：0未读，1已读
					},
				}).then(({data:res})=>{
					this.backlog = res.data||[];
					this.backlog.forEach((item)=>{
						item.date = item.createTime?item.createTime.split(' ')[0]:''
					})
					// 消息类型： 0 供应商审核
					// 消息类型： 1 供应商收到  采购员 发布了询价轮次的消息
					// 消息类型： 2 采购员收到  供应商提交了报价信息
					// 消息类型： 3 评委收到  	评委收到待审批信息
					// 消息类型： 4 采购领导收到  	采购领导收到待审批信息
					// 消息类型： 5 分管领导收到  	分管领导收到待审批信息
					// 消息类型： 6 公司领导收到  	公司领导收到待审批信息
					// 消息类型： 7 订单采购员收到  	订单采购员收到待审批审批驳回
					// 消息类型： 8 订单采购员收到  	订单采购员收到待审批审批完成
					// 消息类型： 9 供应商收到  	订单采购员收到中标通知
					// 消息类型： 10 供应商收到  	供应商 收注册审批消息
				})
			},
			shouMsg(info){
				this.readySysMessage(info.id,()=>{
					if(info.messageType == 0){  // 供应商审批角色收到审批消息
						this.$router.push({path: `/gysmng/audit`});
					}
					if(info.messageType == 11) {	// 供应商审批角色收到供应商变更审批消息
						this.$router.push({path: `/gysmng/change`});
					}
					if(info.messageType == 1){  // 供应商收到  采购员 发布了询价轮次的消息
						this.$router.push({path: `/inquiryDetail/inquiryDetail?hId=${info.objId}&show=false`});
					}
					if(info.messageType == 2){  // 采购员收到  供应商提交了报价信息
						this.$router.push({path: `/inquiryDetail/inquiryDetail?hId=${info.objId}&show=false`});
					}
					if(info.messageType == 3 || info.messageType == 4 || info.messageType == 5 || info.messageType == 6){  // 评委、采购领导、分管领导、公司领导收到待审批信息
						this.$router.push({path: `/inquiryDetail/inquiryDetail?hId=${info.objId}&show=false`});
					}
					if(info.messageType == 7 || info.messageType == 8 || info.messageType == 9){  // 订单采购员收到审批驳回、审批完成、供应商收到中标通知
						this.$router.push({path: `/inquiryDetail/inquiryDetail?hId=${info.objId}&show=false`});
					}
					if(info.messageType == 10){  // 供应商收到  采购员 发布了询价轮次的消息
						this.$router.push({path: `/gys/info`});
					}
				})
			},
			// 标记为已读
			readySysMessage(id,callback){
				readySysMessage({id,readed:1}).then(({data:res})=>{
					if(res.code == 0){
						callback()
					}
				})
			},
			// 获取公告
			async getNoticelist(){
				 let _this = this;
				const {
					data: res
				} = await getNoticeList({
					page: 1, //当前页码
					limit: 10, //当前每页显示的数量
					objMap: {
						status:1,
						noticeType:'',
					}
				})
				if (res.code == 0) {
					_this.qzNotice = res.data||[];
					_this.qzNotice.forEach((item)=>{
						item['date'] = '';
						if(item.createTime){
							item['date'] = item.createTime.split(' ')[0];
						}
					})
				}
			},
			// 获取采购寻源列表
			async getSourcNoticeList(){

				let _this = this;
				const {
					data: res
				} = await sourcNoticeList({
					page: 1, //当前页码
					limit: 10, //当前每页显示的数量
					objMap:{
						status:this.xunyuanstatus
					}
				})
				if (res.code == 0) {
					_this.cgxyNotice = res.data||[];
					_this.cgxyNotice.forEach((item)=>{
						item['date'] = '';
						if(item.createTime){
							item['date'] = item.createTime.split(' ')[0];
						}
					})
				}
			},
			shouNotice(item){
				window.open(`/noticeinfo/${item.id}`)
			},
			// 获取中标公告立碑
			winBidNoticeListFun(){
				let _this = this;
				winBidNoticeList({
					page: 1, //当前页码
					limit: 10, //当前每页显示的数量
				}).then(({data:res})=>{
					if(res.code == 0){
						console.log(res)
						_this.zbggNotice = res.data || [];
						_this.zbggNotice.forEach((item)=>{
						item['date'] = '';
						if(item.createTime){
							item['date'] = item.createTime.split(' ')[0];
						}
					})
					}
				})
			},
			shouZbNotice(item) {
        if(this.checkRole('cgy_role') || this.checkRole('leader') || this.checkRole('pw') || this.checkRole('gys_role')){
				window.open(`/tendernoticeinfo/${item.id}`)
        }else{
          this.$warn('请通过审核后查看！')
        }
			},
			shouCGNotice(item){
      if(this.checkRole('cgy_role') || this.checkRole('leader') || this.checkRole('pw') || this.checkRole('gys_role')){
				window.open(`/cgnoticeinfo/${item.id}`)
      }else{
        this.$warn('请通过审核后查看！')
      }
			},

			// 查看更多
			showMoreList(type){
				this.$router.push({path: `/morenotice/${type}`});
			},
		},
		watch:{
			"xunyuanstatus":function(){
				this.getSourcNoticeList();
			},
			"backstatus":function(){
				this.getsysMessageList();
			},
		}
	}
</script>

<style lang="scss">
	.home-page {
		width: calc(100% - 20px);
		height: calc(100vh - 70px);
		padding-top: 10px;
		padding-bottom: 10px;
		overflow-y: auto;
		overflow-x: hidden;
		display: flex;
		flex-direction: column;
		.home-bottom,.home-top{
			display: flex;
			justify-content: space-between;
		}
		.home-top{
			width: 100%;
			height: 200px;
		}
		.home-bottom{
			margin-top: 10px;
			.home-left{
				display: flex;
				flex-direction: column;
				.cg-bar{
					flex: 6;
				}
				.zb-bar{
					flex: 4;
				}
			}
			.home-right{
				display: flex;
				flex-direction: column;
				.msg-bar{
					flex: 1;
				}
			}
		}
		.notice-list{
			width: calc(100% - 10px);
			padding: 0 5px;
			height: 32px;
			line-height: 32px;
			font-size: 14px;
			display: flex;
			justify-content: space-between;
			cursor: pointer;
			&:hover{
				/* background:rgba(41,190,206,.3); */
				background:#ecf5ff;
			}
			.notice-title{
				flex: 1;
				margin-right: 10px;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				word-break: break-all;
				color: #333;
			}
			.notice-time{
				font-size: 12px;
				color: #999;
			}
		}
		.home-left{
			width: 55%;
			.cg-bar{
				width: 100%;
				background: #fff;
				border-radius: 5px;
				display: flex;
				flex-direction: column;
				.notice-box{
					flex: 1;
					width: calc(100% - 20px);
					padding: 0 10px;
					overflow-y: auto;
					min-height: 220px;
				}
			}
			.zb-bar{
				width: 100%;
				background: #fff;
				border-radius: 5px;
				/* height: 250px; */
				margin-top: 10px;
				display: flex;
				flex-direction: column;
				.notice-box{
					/* height: 200px; */
					flex: 1;
					width: calc(100% - 20px);
					padding: 0 10px;
					overflow-y: auto;
					min-height: 220px;
				}
			}
		}
		.home-right{
			width: calc(45% - 10px);
			.msg-bar{
				width: 100%;
				background: #fff;
				border-radius: 5px;
				.msg-list-box{
					width: calc(100% - 20px);
					min-height: calc(100vh - 340px);
					padding: 10px;
					.msg-list{
						width: calc(100% - 10px);
						padding: 0 5px;
						height: 32px;
						line-height: 32px;
						font-size: 14px;
						display: flex;
						justify-content: space-between;
						cursor: pointer;
						&:hover{
							background:#ecf5ff;
						}
						.msg-title{
							flex: 1;
							margin-right: 10px;
							overflow: hidden;
							white-space: nowrap;
							text-overflow: ellipsis;
							word-break: break-all;
							color: #333;
						}
						.msg-time{
							font-size: 12px;
							color: #999;
						}
					}
				}
			}
		}
		.weather-bar{
			width: 100%;
			min-height: 200px;
			border-radius: 5px;
			background: url('../assets/weather_bg.jpg') no-repeat;
			background-size: cover;
			font-weight: 700;
			color: #fff;
			overflow: hidden;
			.weather-box{
				overflow: hidden;
				width: 100%;
				height: 200px;
			}
			.addr{
				margin-top: 30px;
				margin-left: 50px;
			}
			.wd{
				margin-left: 50px;
				font-size: 50px;
				margin-top: 10px;
				span{
					font-size: 14px;
				}
			}
			.flsd{
				font-size: 14px;
				margin-left: 50px;
				margin-top: 10px;
				span{
					margin-right: 10px;
				}
			}
			.time{
				width: calc(100% - 30px);
				padding-right: 30px;
				text-align: right;
				margin-top: 10px;

			}
		}
		.qiotice-bar{
			width: 100%;
			min-height: 200px;
			background: #fff;
			border-radius: 5px;
			.notice-box{
				height: 150px;
				width: calc(100% - 20px);
				padding: 0 10px;
				overflow-y: auto;
			}
		}
		.bar-title{
			background-color: #ffad4152;
			width: calc(100% - 40px);
			padding: 0 20px;
			height: 40px;
			display: flex;
			justify-content: space-between;
			line-height: 40px;
			.icon-box{
				display: flex;
				align-items: center;
				font-size: 16px;
				img{
					height: 14px;
					margin-right: 10px;
				}
			}
			.show-more{
				font-size: 14px;
				color: #ff9811;
				cursor: pointer;
			}
		}
		.no-data-img{
			width: calc(100% - 40px);
			padding: 20px;
			text-align: center;
			img{
				width: 170px;
			}
		}

	}
</style>
